.rotation-input{display:inline-block;margin-right:8px}
/*# sourceMappingURL=camera-calibration-popover.component.css.map */
